import { render, staticRenderFns } from "./WagonLoadList.vue?vue&type=template&id=21ffa054"
import script from "./wagonLoadList.ts?vue&type=script&lang=js&external"
export * from "./wagonLoadList.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports